module.exports = __webpack_public_path__ + "static/media/t31.da229743.jpg";